import { type BoxStaffItemDto, StaffColumnToSort } from "@modules/boxStaff/gateway/boxStaffDto"
import { MemberDetailedEntity } from "@modules/members/entities/memberEntity"
import {
  MemberColumnToSort,
  type MemberDetailedDto,
  MemberFilter,
  type MemberItemDto,
  type MemberSessionHistoryItemDto,
  type MemberSessionHistorySummaryDto,
} from "@modules/members/gateway/memberDto"
import { ColumnSortingOrder } from "@modules/types/datatableTypes"
import { type Page, type Paginated, type PaginatedWrapper } from "@modules/utils/paginated"

export enum SESSION_HISTORY_STATUS_FILTER {
  ALL = "ALL",
  PRESENT = "PRESENT",
  NO_SHOW = "NO_SHOW",
}

export type MemberApiGateway = {
  getMembers(
    filter: MemberFilter,
    page?: number,
    size?: number,
    nameFilter?: string,
    sortBy?: MemberColumnToSort,
    sortOrder?: ColumnSortingOrder,
  ): Promise<Page<MemberItemDto>>
  getMember(memberId: string): Promise<MemberDetailedDto>
  updateMember(memberId: string, member: MemberDetailedEntity): Promise<MemberDetailedDto>
  archiveMember(memberId: string): Promise<void>
  getArchivedMembers(
    page?: number,
    size?: number,
    nameFilter?: string,
    sortBy?: MemberColumnToSort,
    sortOrder?: ColumnSortingOrder,
  ): Promise<PaginatedWrapper<MemberItemDto>>
  getArchivedStaffMembers(
    page?: number,
    size?: number,
    nameFilter?: string,
    sortBy?: StaffColumnToSort,
    sortOrder?: ColumnSortingOrder,
  ): Promise<PaginatedWrapper<BoxStaffItemDto>>
  getMemberSessionHistorySummary(
    memberId: string,
    year: number,
    month: number | null,
  ): Promise<MemberSessionHistorySummaryDto>
  getMemberSessionHistoryList(
    memberId: string,
    year: number,
    month: number | null,
    status: SESSION_HISTORY_STATUS_FILTER,
    page: number,
    pageSize: number,
  ): Promise<Paginated<MemberSessionHistoryItemDto>>
}
